export const blockIconsBusinessandpaymentsReceiptNew = (
	<span className='material-symbols-outlined'>receipt</span>
);
